<h2 class="export-title">Export drawings</h2>

<div class="export-options" role="radiogroup" aria-label="What to export">
  <label class="export-option" [class.export-option--on]="kind === 'current'">
    <input type="radio" name="drawing-export-kind" value="current" data-testid="drawings-export-current" [checked]="kind === 'current'" (change)="kind = 'current'" />
    <span>
      <span class="option-title mat-body-1">Current set</span>
      <span class="option-text">Every current sheet as a PDF with its shared redlines, plus index.csv.</span>
    </span>
  </label>
  <label class="export-option" [class.export-option--on]="kind === 'as_built'">
    <input type="radio" name="drawing-export-kind" value="as_built" data-testid="drawings-export-as-built" [checked]="kind === 'as_built'" (change)="kind = 'as_built'" />
    <span>
      <span class="option-title mat-body-1">As-built record set</span>
      <span class="option-text">The current set, with deviations.csv listing every as-built mark and its review.</span>
    </span>
  </label>
</div>

<p class="export-note mat-caption">We will also email you the link when it is ready.</p>

<div class="export-actions">
  <app-secondary-button buttonId="drawings-export-cancel" data-testid="drawings-export-cancel" (handleClick)="cancel()">Cancel</app-secondary-button>
  <app-primary-button buttonId="drawings-export-submit" data-testid="drawings-export-submit" (handleClick)="export()">Export</app-primary-button>
</div>
